<template>
  <v-card class="create-rbu">
    <v-card-title>
      {{ title }}
    </v-card-title>
    <v-card-text class="d-flex flex-column">
      <v-form ref="form">
        <v-text-field
          outlined
          dense
          :label="'Previous Item No. (For relocation purpose only)'"
          v-model="result.previous_item_no"
        ></v-text-field>
        <v-text-field
          outlined
          dense
          :label="$t('rbu_item.dummy_item_no')"
          v-model="result.dummy_item_no"
          :rules="requiredRules"
        ></v-text-field>
        <!--        <v-text-field outlined-->
        <!--                      dense-->
        <!--                      :label="$t('rbu_item.current_item_no')"-->
        <!--                      v-model="result.current_item_no"></v-text-field>-->
      </v-form>
    </v-card-text>
    <v-card-actions>
      <v-btn color="secondary" @click="$emit('submit', false)" depressed large>
        {{ $t("cancel") }}
      </v-btn>
      <v-spacer></v-spacer>
      <v-btn
        color="primary"
        @click="$refs.form.validate() && save()"
        depressed
        large
      >
        {{ $t("ok") }}
      </v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
import { ref } from "@vue/composition-api";
import { ACTION_TYPES } from "@/store/types";

export default {
  name: "CreateRbuItemDialog",
  props: {
    sectionId: String,
    duplicatedItemId: String,
    title: String,
    duplicateItemNo: String,
  },
  setup(props, { root, emit }) {
    const requiredRules = ref([
      (value) => !!value || root.$t("rules.required"),
      (value) =>
        (!!value && !!value.match(/^\d+(\.\d+)?[A-L]$/)) ||
        `Dummy Item no. should not contain letters in the middle and should end with [A-L]`,
    ]);

    const result = ref({
      section_id: props.sectionId,
      duplicated_item_id: props.duplicatedItemId,
    });

    const save = async function () {
      const response = await root.$store.dispatch(ACTION_TYPES.CALL_API, {
        url: "admin/rbu/item/create/",
        params: {
          ...result.value,
        },
      });

      if (response.body.success) {
        emit("submit", response.body.item.id);
      }
    };

    return {
      requiredRules,
      result,
      save,
      props,
    };
  },
};
</script>
